/** @file Packs a rig colour string, reporting bad input with its JSON path. */
import { color } from '@pose2d/math/color';
import { coreFail } from '../coreFail';

const HEX = /^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/;

/** `math/color.pack` word of '#rrggbb' (alpha 255) or '#rrggbbaa'; VALIDATION at path for anything else. */
export function packHex(hex: string, path: string): number {
  if (!HEX.test(hex)) coreFail('VALIDATION', `"${hex}" is not a #rrggbb or #rrggbbaa colour`, { path });
  return color.parseHex(hex);
}
